var debounce = debounce || function(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            const wasOpen = this.toggle.hasAttribute('open');
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
            // Focus sat inside the now-hidden menu (lost for keyboard and screen readers) and the page stayed scroll-locked.
            if (wasOpen) {
              document.body.classList.remove('overflow-hidden');
              this.toggle.querySelector('.mobile-toggle').focus();
            }
          }
        }
      });
      this._stickyOffset = 0;
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
        this._stickyOffset = this.offsetTop;
        window.addEventListener('resize', debounce(() => {
          this._stickyOffset = this.offsetTop;
        }, 100), { passive: true });
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Consolidated scroll listener with rAF coalescing
      this._scrollRafId = null;
      const onScroll = () => {
        if (this._scrollRafId) return;
        this._scrollRafId = requestAnimationFrame(() => {
          this._scrollRafId = null;
          this.setStickyClass();
          this.setHeaderOffset();
          this.setHeaderHeight();
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });

      onScroll();

      if (document.querySelector('.announcement-bar-section')) {
        this.setAnnouncementHeight();
        window.addEventListener('resize', debounce(() => {
          this.setAnnouncementHeight();
        }, 100), { passive: true });
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        this.classList.toggle('is-sticky', window.scrollY >= this._stickyOffset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      // These run every scroll frame: writing a variable on <html> restyles the whole page, so only write changes.
      if (h === this._headerOffset) return;
      this._headerOffset = h;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      if (h === this._headerHeight) return;
      this._headerHeight = h;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');

      // Hydrate deferred sub-menu on first open
      const tpl = detailsElement.querySelector(':scope > .mobile-menu-deferred');
      if (tpl) {
        detailsElement.appendChild(tpl.content);
        tpl.remove();
        detailsElement.querySelectorAll('summary').forEach(s => s.addEventListener('click', this.onSummaryClick.bind(this)));
      }

      // Accordion behavior: when opening, close any sibling <details> at
      // the same level. The DOM structure is <ul> > <li> > <details>, so
      // walk up to the enclosing <ul> and collect all open <details> in
      // that <ul> (excluding nested ones from deeper sub-menus).
      if (!isOpen) {
        const parentList = detailsElement.closest('ul');
        if (parentList) {
          parentList.querySelectorAll(':scope > li > details[open]').forEach(sibling => {
            if (sibling !== detailsElement) {
              sibling.removeAttribute('open');
              sibling.classList.remove('menu-opening');
            }
          });
        }
        // Mark as opening so CSS reveal kicks in on next frame
        requestAnimationFrame(() => {
          detailsElement.classList.add('menu-opening');
        });
      } else {
        detailsElement.classList.remove('menu-opening');
      }
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function() {
        window.addEventListener('resize', debounce(function() {
          _this.resizeSubMenus();
        }, 100));
      });

    }
    resizeSubMenus() {
      let updates = [];
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;
          updates.push({ el: sub_submenu.parentElement, needsLeft: total > window.innerWidth });
        });
      });
      updates.forEach(({ el, needsLeft }) => {
        el.classList.toggle('left-submenu', needsLeft);
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}